(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/slides.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/slides.js');
"use strict";

const {
  useRef,
  useCallback,
  useState,
  useMemo,
  useEffect,
  Children,
  isValidElement,
  cloneElement
} = React;
const {
  SlideIndicator,
  useBuildAnimations
} = svs.components.onboarding.slides;

const Slides = _ref => {
  let {
    children,
    className: classNames,
    onSlideChange,
    animations,
    keepSlides
  } = _ref;
  const [activeSlide, setActiveSlide] = useState(0);
  const isAnimating = useRef(false);
  const slidesElRef = useRef(new Map());
  const [slidesRef, setSlidesRef] = useState();
  const [resetPositions, slideLeftAsync, slideRightAsync] = useBuildAnimations(animations, keepSlides);
  const [preparedSlides, preparedSlidesCount] = useMemo(() => {
    const arrayOfSlides = Children.toArray(children);
    const childs = Children.map(arrayOfSlides, (child, index) => {
      if (isValidElement(child)) {
        return cloneElement(child, {
          ref: ref => {
            slidesElRef.current.set(index, ref);
          }
        });
      }
      return null;
    });
    return [childs, Children.count(childs)];
  }, [children]);
  const changeSlide = useCallback(async newSlideIndex => {
    if (newSlideIndex === activeSlide || isAnimating.current) {
      return;
    }
    let arr;
    let animationAsyncFn;
    const shouldAnimateOut = newSlideIndex < activeSlide;
    const shouldAnimateIn = newSlideIndex > activeSlide;
    if (shouldAnimateOut) {
      animationAsyncFn = slideRightAsync;
    } else if (shouldAnimateIn) {
      animationAsyncFn = slideLeftAsync;
    }
    if (keepSlides) {
      const outEl = [];
      const inEl = [];
      slidesElRef.current.forEach((el, index) => {
        if (shouldAnimateIn && index > activeSlide && index <= newSlideIndex) {
          inEl.push(el);
        } else if (shouldAnimateOut && index <= activeSlide && index > newSlideIndex) {
          outEl.push(el);
        }
      });
      outEl.reverse();
      arr = [outEl, inEl];
    } else {
      arr = [[slidesElRef.current.get(activeSlide)], [slidesElRef.current.get(newSlideIndex)]];
    }
    isAnimating.current = true;
    if (onSlideChange) {
      onSlideChange(newSlideIndex);
    }
    await animationAsyncFn(arr);
    setActiveSlide(newSlideIndex);
    isAnimating.current = false;
  }, [activeSlide, onSlideChange, slideLeftAsync, slideRightAsync, keepSlides]);
  const className = ['pg_onboardingslides'];
  if (classNames) {
    className.push(classNames);
  }
  const nextDisalbed = activeSlide >= preparedSlidesCount - 1;
  const prevDisalbed = activeSlide <= 0;
  const nextSlide = useCallback(() => {
    if (!nextDisalbed) {
      changeSlide(activeSlide + 1);
    }
  }, [activeSlide, changeSlide, nextDisalbed]);
  const prevSlide = useCallback(() => {
    if (!prevDisalbed) {
      changeSlide(activeSlide - 1);
    }
  }, [activeSlide, prevDisalbed, changeSlide]);
  useEffect(() => {
    const slideRefEl = slidesRef;
    const slidePreventSizeLeft = 20;
    const slidePreventSizeRight = slidePreventSizeLeft * -1;
    const slideFlipSizeLeft = 60;
    const slideFlipSizeRight = slideFlipSizeLeft * -1;
    let slideStartPos;
    const touchStart = e => {
      slideStartPos = e.touches[0].screenX;
    };
    const touchMove = e => {
      const slideMoveDiff = slideStartPos - e.touches[0].screenX;
      if (slideMoveDiff < slidePreventSizeRight || slideMoveDiff > slidePreventSizeLeft) {
        e.preventDefault();
      }
      if (slideMoveDiff < slideFlipSizeRight) {
        prevSlide();
      } else if (slideMoveDiff > slideFlipSizeLeft) {
        nextSlide();
      }
    };
    if (slideRefEl) {
      slideRefEl.addEventListener('touchstart', touchStart);
      slideRefEl.addEventListener('touchmove', touchMove);
    }
    return () => {
      if (slideRefEl) {
        slideRefEl.removeEventListener('touchstart', touchStart);
        slideRefEl.removeEventListener('touchmove', touchMove);
      }
    };
  }, [nextSlide, prevSlide, slidesRef]);
  useEffect(() => {
    const resetPositionsFn = async () => {
      const arr = Array.from(slidesElRef.current.values());
      await resetPositions(arr);
    };
    resetPositionsFn();
  }, []);
  return React.createElement("div", {
    className: className.join(' '),
    ref: slidesElRef => {
      setSlidesRef(slidesElRef);
    }
  }, preparedSlides, React.createElement(SlideIndicator, {
    activeSlide: activeSlide,
    branding: "inverted",
    isNextDisalbed: nextDisalbed,
    isPrevDisalbed: prevDisalbed,
    nextSlide: nextSlide,
    prevSlide: prevSlide,
    setActiveSlide: changeSlide,
    totalCount: preparedSlidesCount
  }));
};
setGlobal('svs.components.onboarding.slides.Slides', Slides);

 })(window);